import { jsxs, jsx } from "react/jsx-runtime";
import { useIsCompactVoiceLayout } from "../../hooks/useIsCompactVoiceLayout.js";
const WIDGET_KEYFRAMES = `
@keyframes voice-widget-fade-in {
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
}
`;
function MiniCard({ product }) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        background: "var(--voice-widget-card-bg, #FFFFFF)",
        border: "1px solid var(--voice-widget-border, #E5E7EB)",
        borderRadius: 10,
        padding: "10px 8px",
        display: "flex",
        flexDirection: "column",
        gap: 6,
        animation: "voice-widget-fade-in 0.28s ease-out both",
        minWidth: 0
      },
      children: [
        product.imageUrl && /* @__PURE__ */ jsx(
          "img",
          {
            src: product.imageUrl,
            alt: product.title,
            style: {
              width: "100%",
              height: 56,
              objectFit: "contain",
              borderRadius: 6,
              background: "var(--voice-widget-img-bg, #F9FAFB)"
            }
          }
        ),
        /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              fontSize: 11,
              fontWeight: 600,
              color: "var(--voice-widget-fg, #111827)",
              lineHeight: 1.3,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden"
            },
            children: product.title
          }
        ),
        /* @__PURE__ */ jsx("div", { style: { fontSize: 13, fontWeight: 700, color: "var(--voice-widget-price, #111827)", marginTop: "auto" }, children: product.price })
      ]
    }
  );
}
const CarouselsWidget = ({ data }) => {
  const sections = data.sections.slice(0, 4);
  const isCompact = useIsCompactVoiceLayout();
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        width: "100%",
        maxWidth: 700,
        padding: "12px 12px 8px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        gap: 14,
        overflowY: "auto",
        maxHeight: "100%"
      },
      children: [
        /* @__PURE__ */ jsx("style", { children: WIDGET_KEYFRAMES }),
        sections.map((section) => /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx(
            "div",
            {
              style: {
                fontSize: 11,
                fontWeight: 700,
                color: "var(--voice-widget-muted, #6B7280)",
                textTransform: "uppercase",
                letterSpacing: 0.8,
                marginBottom: 8
              },
              children: section.title
            }
          ),
          /* @__PURE__ */ jsx(
            "div",
            {
              style: {
                display: "grid",
                gridTemplateColumns: isCompact ? "repeat(2, minmax(0, 1fr))" : `repeat(${Math.min(section.products.length, 4)}, 1fr)`,
                gap: 8
              },
              children: section.products.slice(0, isCompact ? 6 : 4).map((p) => /* @__PURE__ */ jsx(MiniCard, { product: p }, p.stacklineSku))
            }
          )
        ] }, section.title))
      ]
    }
  );
};
export {
  CarouselsWidget
};
//# sourceMappingURL=CarouselsWidget.js.map
